<template>
  <v-form ref="form">
    <v-row justify="center">
      <v-dialog v-model="showTaggerModal" persistent >
        <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template>
        <div class="flex-container">
          <div id="image-container">
            <inner-image-zoom :src="photo.image_url" moveType="drag" className="tag-image-zoom" />
          </div>
          <div id="tagging-menu">
            <v-card>
              <v-card-title>
                <span class="headline">Add Tags</span>
              </v-card-title>
              <v-card-text>
                <v-row v-if="isSa === false" >
                  <v-col cols="6">
                    <v-row align="end">
                      <v-col cols="3">
                        <v-autocomplete
                          class="mt-4"
                          :items="allCats"
                          label="Category"
                          item-text="name"
                          item-value="id"
                          @input="filterTags"
                          :value="allCats[0].id"
                          />
                      </v-col>
                      <v-col cols="7" >
                        <v-autocomplete
                          class="mt-4"
                          v-model="selectedTagsModal"
                          :items="filteredTags"
                          chips
                          label="Tags"
                          item-text="name"
                          item-value="id"
                          :value="selected.tags"
                          :search-input.sync="searchInput"
                          @change="searchInput=''"
                          @input="logInput"
                          multiple
                          >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              small
                              @click="data.select"
                              @click:close="removeTagFromList(data.item)"
                            >
                              <span class="text-truncate">  {{ data.item.name }} </span> &nbsp; <b class="text-truncate" style="font-size:11px;">  ({{data.item.category.name}})</b>
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                              <v-list-item-content >
                                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                  <v-list-item-subtitle v-html="data.item.category.name"></v-list-item-subtitle>
                              </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4" display="flex" align-self="start" justify-content="flex-start" v-if="isSa === false">
                    <small class=" text-xl-left font-weight-300 mb-3">Tags to Apply</small>
                    <v-chip-group active-class="primary--text" column >
                      <v-chip
                        v-for="tag in selected.tags" :key="tag.id"
                        close
                        @click:close="removeTagFromList(tag)"
                      >
                        <span class="text-truncate"> {{ tag.name }} </span> &nbsp; <b class="text-truncate" style="font-size:11px;">  ({{tag.category.name}})</b>
                      </v-chip>
                    </v-chip-group>
                  </v-col>
                  <v-col cols="2" align-self="center" v-if="isSa === false">
                    <v-btn  color="primary" class="mr-2" @click="tagPhoto">
                      Apply
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <span>Response ID: {{photo.response_id}}</span>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" depressed @click="closeTaggerModal()">Close</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </div>
        </div>
      </v-dialog>
    </v-row>
  </v-form>
</template>

<script>
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import imageZoom from "vue-image-zoomer";
import InnerImageZoom from 'vue-inner-image-zoom'

export default {
  name: 'TaggerModal',
  components: {
    'inner-image-zoom': InnerImageZoom
  },
  props: {
    isQc: {
      type: Boolean,
      default: false
    },
    isSa: {
      type: Boolean,
      default: false
    },
    photo: Object
  },
  watch: {
    'selectedTagsModal': function (val) {
      let arr = []
      val.forEach(v => {
        var filteredTags = this.tags.find(tag => tag.id === parseInt(v))
        arr.push(filteredTags)
      })
      this.selected.tags = arr
    }
  },
  data () {
    return {
      searchInput: null,
      selected: {
        tags: [],
        categories: []
      },
      selectedTagsModal: [],
      dialog: {
        tags: false,
        categories: false,
        modal: false
      },
      isModalVisible: false
    }
  },
  mounted () {
    this.setFilteredTags(this.visibleTags)
    this.setSelectedTagsModal(this.$store.state.tags.selectedTags)
    // if (this.isQc) {
    //   this.sortOptions.push({
    //     name: 'Tagger',
    //     id: 'tagger',
    //     descending: true
    //   })
    // }
  },
  computed: {
    ...mapGetters(['getCategoryNames', 'getTagNames', 'visibleCategories', 'visibleTags', 'retainHumanTags']),
    ...mapState({
      filteredTags: state => state.tags.filteredTags,
      tags: state => state.tags.tags,
      categories: state => state.categories.categories,

      allCats () {
        // IT-704 (P4): machine-owned (derived) categories/tags drop out of the
        // pick lists once derivation is enabled.
        var cats = this.visibleCategories
        cats = cats.map(cat => ({ id: cat.id, name: cat.name }))
        cats.unshift({ id: 0, name: 'All' })
        var filteredTags = this.visibleTags
        this.setFilteredTags(filteredTags)
        return cats
      }
    })
  },
  methods: {
    ...mapActions([
      'bulkUpdate',
      'submitAssigned',
      'getQCList',
      'getSAList'
    ]),
    ...mapMutations([
      'setMessage',
      'setPhotos',
      'setTags',
      'setFilteredTags',
      'setSelectedTags',
      'setQCPhotos'
    ]),
    filterTags (e) {
      if (e !== 0) {
        var filteredTags = this.visibleTags.filter(tag => tag.category.id === parseInt(e))
      } else {
        filteredTags = this.visibleTags
      }
      this.setFilteredTags(filteredTags)
    },
    logInput (e) {
      this.setSelectedTagsModal(e)
    },
    removeTagFromList (item) {
      var tags = this.selectedTagsModal
      tags.splice()
      let index = tags.indexOf(item.id);
      if (index >= 0) tags.splice(index, 1)
      this.setSelectedTagsModal(tags)
    },
    setSelectedTagsModal () {},
    tagPhoto () {
      let valid = this.$refs.form.validate();
      if (valid) {
        let selectedPhoto = this.photo
        let that = this;
        // IT-704 (P4): when derivation is on, echo only human-picked tags.
        let currentTags = that.retainHumanTags(selectedPhoto.tags).map(tag => tag.id);
        let selectedTags = that.selectedTagsModal.concat(currentTags);
        let payload = {
          selected_photos: [selectedPhoto.id],
          selected_tags: selectedTags,
          isQc: this.isQc,
          needs_review: this.needsReview
        };
        this.bulkUpdate(payload).then(() => {
          let message
          if (selectedTags.length > 0) {
            message = {
              text: 'Photos Tagged Successfully',
              type: 'success',
              alert: true
            }
          } else {
            message = {
              text: 'No Tags Selected',
              type: 'success',
              alert: true
            }
          }
          this.setMessage(message)
        })
        this.closeTaggerModal()
      }
    },
    showTaggerModal () {
      this.isModalVisible = true
    },
    closeTaggerModal () {
      this.isModalVisible = false
      this.$emit('close')
    }
  }
}
</script>

<style>
.v-chip .v-chip__content {
  height: auto !important;
}

.flex-container {
  display: flex;
  justify-content: center;
}

#image-container {
  flex: 1;
  margin: auto;
  padding-left: 1vw;
  padding-top: 1vh;
}

#tagging-menu{
  flex: 2;
  max-width: 100%;
  padding-left: 1vw;
  padding-right: 1vw;
  margin: auto;
}

@media (min-width: 960px) {
  .tag-image-zoom{
  width: 400px;
  max-width: 400px;
}
}
@media (min-width: 1264px) {
  .tag-image-zoom{
  width: 700px;
  max-width: 700px;
}
}
@media (min-width: 1904px) {
  .tag-image-zoom{
  width: 940px;
  max-width: 940px;
}
}

</style>
